import "./Gallery.module.css";
import Header from "@/reusable_sections/Header";
import GalleryHero from "./sections/GalleryHero";
import PhotoGallery from "./sections/PhotoGallery";
import Footer from "@/reusable_sections/Footer";
export default function GalleryPage() {
  return <div>
      <Header />
      <GalleryHero />
      <PhotoGallery />
      <Footer />
    </div>;
}